module.exports = __webpack_public_path__ + "static/media/km.a4e99344.svg";